<template>
  <div>
    <b-tabs v-model="index">
      <b-tab title="Group(Customer)">
        <b-row>
          <b-col lg="12" xl="12">
            <b-card border-variant="primary">
              <div slot="header">
                <strong>Group Info</strong>
                <span class="float-right"> Last_visit : {{model.joined_at | datetime}}</span>
              </div>
              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <label for="ph_name">Group Name(*)</label>
                    <b-form-input md=12 type="text" id="ph_name" v-model="model.groupname" :disabled="lock"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6" v-if="lock">
                  <b-form-group>
                    <h5 class="text-center mt-0">
                      <small>
                        Usage Solution
                        (<b-button variant="link" @click="index = 5" class="px-0">Install History</b-button>)
                      </small>
                      <br>
                      <b-badge class="mt-4" variant="danger">WEBCastle : {{model.info.wc_count}} </b-badge>
                      <b-badge class="mt-4" variant="warning">WSFinder : {{model.info.wsf_count}} </b-badge>
                      <b-badge class="mt-4" variant="success">WMDS : {{model.info.wmds_count}} </b-badge>
                      <b-badge class="mt-4" variant="info">WFDetector : {{model.info.wf_count}} </b-badge>
                    </h5>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col :md="6">
                  <b-form-group>
                    <label for="ph_service" v-b-tooltip.hover title="Service">Service(*)</label>
                    <v-select :readonly="true" @input="set_service" v-if="!lock" label="service_name" v-model="model.service" :options="partner_service"></v-select>
                    <h4 v-else>
                      <b-badge  :variant="model.service_name === 'Basic' ? 'info' : 'success'"> {{model.service.service_name}} </b-badge>
                    </h4>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group label="Invoice" v-b-tooltip.hover title="Sets whether issued invoice is sent or not. Only 'Owner' accounts can be set.">
                    <c-switch :disabled="lock" color="info" label size="sm" v-model="model.allow_invoice"/>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group label="Verified" label-for="ph_use"
                    v-b-tooltip.hover title="Verified Allow login.">
                    <c-switch color="info" label size="sm" v-model="model.is_verified" :disabled="lock" />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group label="Member's" label-for="ph_count"
                    v-b-tooltip.hover title="Verified Allow login.">
                    {{model.Count || 0}}
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <label for="ph_email" v-b-tooltip.hover title="Email">E-mail(*)</label>
                    <b-form-input type="text" id="ph_email" :value="model.email" v-model="model.email" :disabled="lock"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="contact" label-for="ph_contact" v-b-tooltip.hover title="contact.">
                    <b-form-input type="text" id="ph_contact" :value="model.contact" v-model="model.contact" :disabled="lock"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label for="ph_address">Address(*)</label>
                    <b-form-input md=12 type="text" id="ph_address" v-model="model.address" :disabled="lock"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <h4>Region</h4>
              <hr>
              <b-row>
                <b-col md="6">
                  <b-form-group>
                    <label for="ph_country_group" v-b-tooltip.hover title="country">Country(*)</label>
                    <v-select :readonly="true" @input="set_country" :disabled="lock" label="name" v-model="region.country" :options="codes.country" ></v-select>
                    <!-- <v-select :readonly="true" @input="set_country" :disabled="lock" v-model="region.country" :options="codes.country_full" ></v-select> -->
                    <!-- <b-form-input type="text" id="ph_service" v-if="lock" v-model="codes.country_map[model.country]" :disabled="lock"></b-form-input> -->
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group>
                    <label for="ph_language_group" v-b-tooltip.hover title="language">language(*)</label>
                    <v-select :readonly="true" @input="set_language" :disabled="lock" label="name" v-model="region.language" :options="codes.language"></v-select>
                    <!-- <v-select :readonly="true" @input="set_language" :disabled="lock" v-model="region.language" :options="codes.language_full"></v-select> -->
                    <!-- <b-form-input v-else type="text" id="ph_language" v-model="codes.language_map[model.language]" :disabled="lock"></b-form-input> -->
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group>
                    <label for="ph_timezone_group" v-b-tooltip.hover title="Timezone">Timezone(*)</label>
                    <v-select :readonly="true" @input="set_timezone" :disabled="lock" label="name" v-model="region.timezone" :options="codes.timezone" ></v-select>
                    <!-- <v-select :readonly="true" @input="set_timezone" :disabled="lock" v-model="region.timezone" :options="codes.timezone_full" ></v-select> -->
                    <!-- <b-form-input type="text" id="ph_timezone" v-if="lock" v-model="codes.timezone_map[model.timezone]" :disabled="lock"></b-form-input> -->
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>
              <b-button v-if="!lock" size="sm" variant="success" @click="save"> Save </b-button>
              <b-button v-else size="sm" variant="warning" @click="edit">Edit </b-button>
              <b-button v-if="!lock" size="sm" variant="info" @click="cancel"> Cancel </b-button>
              <b-button size="sm" variant="danger" @click="confirm = true;" v-if="model.id && lock"> Remove </b-button>
              <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>

              <!-- end partner info -->
              <hr>
            </b-card>
          </b-col>
        </b-row>
      </b-tab>
      <!-- 고객사 사용자 리스트 -->
      <b-tab title="User List" :disabled="$route.params.id == 'add'">
        <user-list v-if="model.id" :group="model" :view_detail="false"/>
      </b-tab>
      <!-- 과금내역 -->
      <!-- 매니저는 권한 없음 -->
      <b-tab :title="auth.profile.permissions == 'manager' ? 'Require invoice permission' : 'Invoice'" :disabled="$route.params.id == 'add' || auth.profile.permissions == 'manager'">
        <!-- 인보이스 목록 -->
        <InvoiceList :view_detail="false" v-if="model.id" ref="invoice_list" :group_id="model.id" @select="show_invoice" @refresh />
        <!-- <billing-list v-if="model.id" :group_id="model.id"/> -->
      </b-tab>
      <!-- 매니저는 권한 없음 -->
      <!-- 파트너 에이전트 제한 수량 -->
      <b-tab :title="auth.profile.permissions == 'manager' ? 'Require billing permission' : 'Agent Qty Limit'" :disabled="$route.params.id == 'add' || auth.profile.permissions == 'manager'">
        <b-row>
          <b-col md="12">
            <b-form-group>
              <h3 class="text-center">Total Agent Qty</h3>
              <hr>
              <center>
                <b-badge variant="info" class="avatar-status">WEBCastle</b-badge>
                <b-badge variant="primary" class="avatar-status">WSFinder</b-badge>
                <b-badge variant="warning" class="avatar-status">WMDS</b-badge>
                <b-badge variant="danger" class="avatar-status">WFDetector</b-badge>
                <hr>
                <span>
                  * There is a total installation limit of 4 solutions per customer (group)
                </span>
              </center>
              <hr>
              <b-input-group size="sm" prepend="#">
                <b-form-input v-model="subscription.service_qty" placeholder="0" type="number"></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_address">Comment(*)</label>
                <b-textarea v-model="subscription.reason"></b-textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-card class="g">
                <b-button-group>
                  <b-button size="sm" variant="info" v-on:click="subscription.service_qty += 10">10</b-button>
                  <b-button size="sm" variant="info" v-on:click="subscription.service_qty += 50">50</b-button>
                  <b-button size="sm" variant="info" v-on:click="subscription.service_qty += 100">100</b-button>
                </b-button-group>

                <b-button-group>
                  <b-button size="sm" variant="warning" v-on:click="subscription.service_qty -= 10">-10</b-button>
                  <b-button size="sm" variant="warning" v-on:click="subscription.service_qty -= 50">-50</b-button>
                  <b-button size="sm" variant="warning" v-on:click="subscription.service_qty -= 100">-100</b-button>
                </b-button-group>
                <b-button-group class="pull-right">
                  <b-button size="sm" variant="primary" @click="confirm_qty_update = true">Update</b-button>
                </b-button-group>
              </b-card>
            </b-col>
          </b-row>
      </b-tab>
      <!-- 매니저는 권한 없음 -->
      <!-- 멤버쉽(구독정보) 해지 -->
      <b-tab
        :title="auth.profile.permissions == 'manager' ? 'Require billing permission' : 'Membership'"
        :disabled="$route.params.id == 'add' || auth.profile.permissions == 'manager'"
        @click="signout_status"
      >
        <b-row>
          <b-col md="12">
            <h4>
              <center>Subsctiptoin Status :
                <b-badge  :variant="status.all_bill_pay && status.processing ? (status.approve ? 'danger' : 'warning') : 'success'">
                  {{status.all_bill_pay && status.processing ? (status.approve ? 'End of service' : 'Stoped') : 'Using'}}
                </b-badge>
              </center>
            </h4>
          </b-col>
        </b-row>
        <hr>
        <div>
          <b-jumbotron>
            <b-button class="text-left" :disabled="status.all_bill_pay" variant="primary" href="#" @click="request_billing">
              <del v-if="status.all_bill_pay">STEP.1 Request to Billing this month.</del>
              <span v-else>STEP.1 Request to Billing this month.</span>
            </b-button>
            <span v-if="status.all_bill_pay">✔️ Clear</span>
            <br>
            <br>
            <!-- moㅕve to billing -->
            <h4 class="lead">* Make sure you don't have any outstanding payments</h4>
            <h4 class="lead">* Go to <a href="#" @click="index = 2">Billing</a></h4>
            <hr>
            <b-button class="text-left" variant="warning" :disabled="status.all_bill_pay && status.processing" href="#" @click="signout_stop">
              <del v-if="status.all_bill_pay && status.processing">STEP.2 Request to stop and this month billing</del>
              <span v-else>STEP.2 Request to stop and this month billing</span>
            </b-button>
            <span v-if="status.all_bill_pay && status.processing">✔️ Clear</span>
            <br>
            <br>
            <!-- 중지 요청해도 서비스는 이용 가능 / 설정 변경 막아야 하는지 확인 필요 -->
            <h4 class="lead">* The agent's settings are kept until approval and cannot be recovered after approval.</h4>
            <h4 class="lead">* If you request a stop, you will no longer be charged.</h4>
            <hr>
            <b-button :disabled="status.all_bill_pay && status.processing && status.approve" class="text-left" variant="success" href="#" @click="signout_cancel">
              STEP.3
              <del v-if="status.all_bill_pay && status.processing && status.approve">
                Continue useing Service
              </del>
              <span v-else>Continue useing Service</span>
            </b-button>
            or
            <b-button :disabled="status.all_bill_pay && status.processing && status.approve" class="text-left" variant="danger" href="#" @click="confirm_signout = true">
              STEP.3
              <del v-if="status.all_bill_pay && status.processing && status.approve">
                 Agree leave our membership, and delete all data
              </del>
              <span v-else>Agree leave our membership, and delete all data</span>
            </b-button>
            <span v-if="status.all_bill_pay && status.processing && status.approve">✔️ Clear</span>
            <br>
            <br>
            <h4 class="lead">* The service in use is stopped.</h4>
            <h4 class="lead">* The agent's settings are kept until approval and cannot be recovered after approval.</h4>
            <hr v-if="status.all_bill_pay && status.processing && status.approve">
            <span v-if="status.all_bill_pay && status.processing && status.approve">✔️ Sign out process all Clear</span>
          </b-jumbotron>
          <hr>
        </div>
      </b-tab>
      <b-tab title="Install History" :disabled="$route.params.id == 'add'" @click="() => $refs.install_history ? $refs.install_history.refresh() : ''">
        <!-- 에이전트 설치 이력 필요 -->
        <InstallHistoryList ref="install_history" :user="model" v-if="model.id" />
      </b-tab>
      <!-- <b-tab title="Summary">
      </b-tab> -->
    </b-tabs>

    <router-view></router-view>
    <!-- start group's user -->
    <!-- <wsfinder-list v-if="model.id && model.service != 'Basic'" :group="model" :delay="2"/> -->
    <!-- end group's user -->
    <!-- start group's user -->
    <!-- <wmds-list v-if="model.id" :group="model" :delay="3"/> -->
    <!-- end group's user -->
    <!-- start group's user -->
    <!-- <webcastle-list v-if="model.id" :group="model" :delay="4"/> -->
    <!-- end group's user -->

    <!-- modal area -->
    <!-- 그룹 삭제 모달 -->
    <b-modal title="Remove"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      If this group have user, can't log in after removed
      <br>
      Check first, this  group's user
      <br>
      Would You Like to Remove the group?
    </b-modal>
    <!-- 가격 정보 모달 -->
    <price :confirm="confirm_price"></price>
    <!-- 유닛 제한 모달 -->
    <b-modal size="xl" title="Apply qty to client"  class="modal-warning" v-model="confirm_qty_update" @ok="update_qty" ok-variant="warning">
      Want to apply the quantity of {{subscription.service_qty}}?
      <hr>
      Amount : {{subscription.origin}} -> {{subscription.service_qty}}
      <hr>
      *<small>{{subscription.reason}}</small>
    </b-modal>
    <!-- 해약 코멘트 모달  -->
    <b-modal size="xs" title=""  class="modal-warning" v-model="confirm_signout" @ok="signout_end" ok-variant="warning">
      you have a comment to customer?
      <hr>
      <b-form-input v-model="signout.description" ></b-form-input>
    </b-modal>
    <b-modal size="xl" title="Group Invoice"  class="modal-warning" v-model="modal_invoice" ok-variant="warning">
      <InvoiceDetail :item="modal_invoice_item" :only_view="true"/>
    </b-modal>
  </div>

</template>
<style>
.a {
  border: 1px solid gray;
  text-align: center;
  font-style: italic;
}
.k {
  /* width : 300px; */
  height: 200px;
}
.g {
  /* width: 33px; */
  height: 100px;
}
.s {
  width: 1075px;
  height: 300px;
}
</style>
<script>
import { Api, auth } from '@/service';
import codes from '@/codes';
import reg from '@/reg';
import UserList from '../user/User.List';
import BillingList from '../billing/Billing';
import Price from '../billing/Price';
import InstallHistoryList from '@/views/Log/install/Install.List'
import InvoiceList from '@/views/Management/invoice/Invoice.List'
import InvoiceDetail from '@/views/Management/invoice/Invoice.Detail'
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import * as _ from 'lodash';

// const default_model = () => ( );

export default {
  components: {
    UserList,
    BillingList,
    cSwitch,
    vSelect,
    Price,
    InstallHistoryList,
    InvoiceList,
    InvoiceDetail,
  },
  data : () => {
    return {
      modal_invoice : false,
      modal_invoice_item: {},
      auth,
      // QTY CONTROL
      subscription : { service_qty : 0, reason : `grant from ${auth.profile.username} `, origin : 0 },
      confirm_qty_update : false,

      partner_service : undefined,
      confirm_price : false,
      so : {
        perPage: 15,
        currentPage: 1, totalRows: 0,
        sk: 'username', sv: '', skt: 'username', opt : {}
      },
      add : false,
      reg,
      confirm : false,
      model : { service : codes.service_default, info : { wc_count : 0, wsf_count : 0, wf_count : 0, wmds_count : 0 } },
      lock : true,
      codes,

      passPartner : false,
      region : {
        language : codes.language_default,
        country : codes.country_default,
        timezone : codes.timezone_default
      },
      index : 0,
      status : {
        all_bill_pay : false,
        processing : false,
        approve : false
      },
      confirm_signout : false,
      signout : { description : "" }
    }
  },
  computed: {},
  methods: {
    show_invoice(item) {
      // id 값만 사용
      this.modal_invoice_item = item;
      this.modal_invoice = true
    },
    signout_status: function() {
      console.log('start signout status process')
      Api.Billing_Call('partner', 'group.signout.status', { group_id : this.model.id }).then(rs => {
        if(rs.error) { return this.$toastr.e(rs.reason, this.$route.name) }
        this.status = Object.assign({}, this.status, rs.body);
      }).catch(e => { this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText) })
    },
    signout_cancel: function() {
      console.log('start signout cancel process')
      if(!this.status.all_bill_pay || !this.status.processing) { return this.$toastr.e("STEP.2 resolve first"); }
      Api.Billing_Call('partner', 'group.service.continue', { group_id : this.model.id }).then(rs => {
        if(rs.error) { return this.$toastr.e(rs.reason, this.$route.name) }
        this.$toastr.s("Changed successfully")
        this.status = Object.assign({}, this.status, { processing : false })
      }).catch(e => { this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText) })
    },
    signout_stop: function() {
      if(!this.status.all_bill_pay) { return this.$toastr.e("STEP.1 resolve first"); }
      console.log("start stopping of plan")
      Api.Billing_Call('partner', 'group.service.stop', { group_id : this.model.id }).then(rs => {
        if(rs.error) { return this.$toastr.e(rs.reason, this.$route.name) }
        this.status = Object.assign({}, this.status, { processing : true })
        this.$toastr.s("request stopping service")
      }).catch(e => { this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText) })
    },
    signout_end: function() {
      if(!this.status.all_bill_pay || !this.status.processing) { return this.$toastr.e("STEP.2 resolve first"); }
      console.log("start signout_end")
      Api.Billing_Call('partner', 'group.service.end', { group_id : this.model.id, description : this.signout.description }).then(rs => {
        if(rs.error) { return this.$toastr.e(rs.reason, this.$route.name) }
        this.$toastr.s("Changed successfully")
        this.status = Object.assign({}, this.status, { approve : true })
      }).catch(e => { this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText) })
    },
    request_billing: function() {
      console.log("start request_billing")
      Api.Billing_Call('partner', 'admin.service.billing', { group_id : this.model.id }).then(rs => {
        if(rs.error) { return this.$toastr.e(rs.reason, this.$route.name) }
        this.$toastr.s("A bill has been issued this month.")
      }).catch(e => { this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText) })
    },
    load_partner_service() {
      try{
       let partner_service_info = {
          target : 'partner.license', cmd : 'service',
          body : { sort : [{ name : "id", op : "desc" }], or : [], and : [] }
        }
        Api.Partner(partner_service_info).then(rs => {
          if(rs.error) { return this.$toastr.e("load failed of license", this.$route.name) }
          this.partner_service = rs.body;
          this.partner_service.forEach(x => { if(this.model.service_id == x.id) { console.log('updated service info'); this.model = Object.assign({}, this.model, { service : x })} })
          if(!this.model.service_id && this.partner_service) { this.model = Object.assign({}, this.model, { service : this.partner_service[0] }) }
        }).catch(e => {
          this.$toastr.e(e.data.message, e.status, e.statusText)
        })
      } catch(e) { this.$toastr.e(e.data.message, e.status, e.statusText); }
    },
    load_using_status() {
        Api.Partner({ target : 'group', cmd : 'info', body : { group_id : this.model.id  } }).then(rs => {
          if(rs.error) { return this.$toastr.e("load failed of license", this.$route.name) }
          this.model.info = Object.assign({}, this.model.info, rs.body)
        }).catch(e => this.$toastr.e(e.data.message, e.status, e.statusText))
    },
    edit:function() { this.lock = false },
    set_service:function(x) { if(!x) { return; } this.model.service_id = x.id },
    set_timezone:function(x) { if(!x) { return; } this.model.timezone = x.value },
    set_country:function(x) { if(!x) { return; } this.model.country = x.value },
    set_language:function(x) { if(!x) { return; } this.model.language = x.value },
    cancel: function() { if(this.$route.params.id == "add") { this.list(); } this.lock = true; },
    list: function() { this.$router.push({ name: 'group' }); this.$emit('refresh') },
    remove: function() {
      this.model.is_del = true;
      if(this.model.count) { this.$toastr.w('User existence', 'Warning'); return; }
      Api.Partner_Call('group', 'delete', { id : this.model.id })
        .then((rs) => {
          if(!rs.error) {
            this.$toastr.s('removed.', this.$route.name);
          } else {
            console.log("remove", 'failed', rs.reason, this.model.id)
            this.$toastr.e('delete', "failed")
          }
          this.list();
        }).catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    },
    update_qty: function() {
      let body = {
        group_id : this.model.id,
        partner_id : this.model.partner_id,
        service_id : this.model.service_id,
        service_qty : this.subscription.service_qty,
        reason : this.subscription.reason + (this.subscription.service_qty > this.subscription.origin ? 'Grant' : 'Revoke'),
      }
      Api.Billing_Call('partner', 'group.service.update', body)
        .then((rs) => {
          if(!rs.error) {
            this.$toastr.s('update.', this.$route.name);
          } else {
            console.log("update", 'failed', rs.reason, this.model.id)
            this.$toastr.e('update', "failed")
          }
        }).catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    },
    save: async function() {
      try {
        if(!(this.model.groupname || '').trim()) { return this.$toastr.e('Group Name is Require.'); }
        if(!this.model.service) { return this.$toastr.e('Service is Require.'); }
        if(!(this.model.email || this.model.contact || '').trim()) { return this.$toastr.e('email or contact is Require.'); }
        if(!(this.model.address || '').trim()) { return this.$toastr.e('address is Require.'); }
        // if(!this.model.partner && !this.model.partner_id) { return this.$toastr.e('partner is Require.'); }

        // set region
        if(!this.region.country) { return this.$toastr.e('Country Required.'); }
        if(!this.region.timezone) { return this.$toastr.e('Timezone Required.'); }
        if(!this.region.language) { return this.$toastr.e('Language Required.'); }

        let model = this.model;
        if(this.model.syslog_list) {
          model.syslog = _.uniq(_.compact(this.model.syslog_list.replace(/,/gm, '').split("\n")));
          // b-form-textarea has bug, can not bind model so rirect update
          this.model.syslog_list = model.syslog.join(model.syslog, '\n')
          this.$refs.syslog_list.localValue = model.syslog.join(model.syslog, '\n')
        }

        let region = {};
        region.country = this.region.country.value
        region.language = this.region.language.value
        region.timezone = this.region.timezone.value

        let service = this.model.service.service_name ? this.model.service.service_name : this.model.service

        let rs = await Api.Partner_Call('group', this.model.id ? 'update' : 'insert', Object.assign({}, this.model, region,  { service : service }));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
        } else {
          this.$toastr.e('Save', "failed");
        }
        this.model.service_name = service;
        this.lock = true;
        this.refresh(rs.body.id)
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); this.list()}
    },

    get: async function({ id, tab } = this.$route.params) {
      if(tab != undefined) { this.index = Number(tab) }

      console.log('group.detail.vue', 'load item', id, tab);
      if(id === 'add') { this.model.is_verified = this.add = true; this.lock = false; this.load_partner_service(); return; }
      else {
        Api.Partner_Call('group','detail',{ id : id }).then(rs => this.model = Object.assign({ group: {} }, this.model, rs.body))
        .then(() => {
          let is_done_country = false;
          codes.country.forEach(r => { if(is_done_country || !this.model.country) { return; } else if(r.value == this.model.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

          let is_done_language = false;
          codes.language.forEach(r => { if(is_done_language || !this.model.language) { return; } else if(r.value == this.model.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

          let is_done_timezone = false;
          codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });

          this.subscription = Object.assign({}, this.subscription, { service_qty : this.model.service_qty, origin : this.model.service_qty })

          this.load_partner_service();
          this.load_using_status()
        }).catch(e => {
          console.log(e)
          this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)
          this.list()
        });

      }
    },
    refresh(id) {
      this.$router.push({ name: 'group', params : { id : id ? id : this.$route.params.id } });
      this.$emit('refresh');
    }
  },
  watch: { '$route' (to, from) { this.get(to.params, from); } },
  created: function() { console.log('group.detail.vue', 'created'); },
  destroyed: function() { console.log('group.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('group.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
